export enum FEATURE_FLAGS_ENUM {
  PLAYBACK_LOGS = "playback_logs",
  PLAYER_LOG_ENABLE = "player_log_enable",
  PERSISTENT_VIDEO = "persistent_video",
  FORCE_USE_SERVICEWORKER_IMAGES = "force_use_serviceworker_images", // switch to foce using service worker instead and enabled to use media cache by default
  DISABLE_PRELOAD_VIDEO = "disable_preload_video",
  SW_VIDEO_CACHE_ENABLED = "sw_video_cache_enabled",
}

export type CurrentFeatureFlag = string[];
